import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "App";
import store from "app/store";
import { SnackbarProvider, closeSnackbar } from "notistack";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <SnackbarProvider
      maxSnack={4}
      autoHideDuration={3000}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      preventDuplicate
      action={(key) => (
        <IconButton
          aria-label="close"
          onClick={() => closeSnackbar(key)}
          sx={{ color: "inherit" }}
          size="small"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    >
      <App />
    </SnackbarProvider>
  </Provider>
);
